import { ENDPOINT_CSS_API, Client } from '../index';

/**
 * Creates a default CSS client.
 * Influence the endpoint's URL by setting an environment variable with the name `ENDPOINT_CSS_API`.
 */
export const createCssClient = () => {
  return new Client({
    BASE: ENDPOINT_CSS_API,
  });
};
